import * as React from 'react'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { MessageBlock, MessageTypes } from '@amzn/dvui/dist/Block'
import { Text } from '@amzn/dvui/dist/Text'
import { LocalizerProps, TextLocalizer, withLocalization } from '../localizer/localizer'
import { IDetailPageState } from '../../reducers'
import { clearBanner, createBanner } from '../../actions/banner'
import { StringId } from '../localizer/stringId'

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  LocalizerProps

const TRANSITION_MS = 300

interface IBannerMessageMap {
  [key: string]: {type: MessageTypes, heading: StringId, body: StringId}
}
const bannerMessageMap: IBannerMessageMap = {
  WP_ERROR: {type: MessageTypes.warning, heading: StringId.DV_DP_WP_ERROR_HEADING, body: StringId.DV_DP_WP_ERROR},
  WP_END: {type: MessageTypes.info, heading: StringId.DV_DP_WP_END_HEADING, body: StringId.DV_DP_WP_END},
  WP_CREATE_INELIGIBLE: {type: MessageTypes.warning, heading: StringId.DV_DP_WP_CREATE_INELIGIBLE_HEADING, body: StringId.DV_DP_WP_CREATE_INELIGIBLE},
  WP_JOIN_INELIGIBLE: {type: MessageTypes.warning, heading: StringId.DV_DP_WP_JOIN_INELIGIBLE_HEADING, body: StringId.DV_DP_WP_JOIN_INELIGIBLE},
  WP_GEO_RESTRICTION: {type: MessageTypes.warning, heading: StringId.DV_DP_WP_GEO_RESTRICTION_HEADING, body: StringId.DV_DP_WP_GEO_RESTRICTION},
}

export class UiBannerComponent extends React.Component<Props> {

  componentDidMount() {
    const { queryParameters, getString, createBanner } = this.props

    const messageCode = queryParameters.bannerMsg

    if (messageCode) {
      const bannerPayload = bannerMessageMap[messageCode.join('').toUpperCase()]
      bannerPayload && createBanner(bannerPayload.type, getString(bannerPayload.heading), getString(bannerPayload.body))
    }
  }

  render() {
    const { banner, clearBanner } = this.props
    if (!banner) {
      return null
    }
    const { stringId, string, type, heading } = banner
    return (
      <MessageBlock heading={heading || ''} type={type} dismissable onDismiss={clearBanner}>
        {stringId && <TextLocalizer stringID={stringId} />}
        {string && <Text string={string} />}
      </MessageBlock>
    )
  }
}

const mapStateToProps = (state: IDetailPageState) => ({
  banner: state.banner.ui,
  queryParameters: state.requestContext && state.requestContext.queryParameters
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  clearBanner: () => setTimeout(() => dispatch(clearBanner()), TRANSITION_MS),
  createBanner: (messageType: MessageTypes, heading: string, string: string) =>
    dispatch(createBanner({ type: messageType, string, heading }))
})

export const UiBanner = withLocalization(connect(
  mapStateToProps,
  mapDispatchToProps
)(UiBannerComponent))
